import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { JOURNEY_STAGES } from "@/lib/content";

const StageCard = ({ stage, align = "left" }) => (
  <div className={`card-surface p-6 text-left ${align === "right" ? "md:ml-auto" : ""} w-full md:max-w-md`}>
    <div className="flex items-center gap-3 mb-2">
      <span className="font-display font-extrabold text-brand-cyan text-lg">{stage.n}</span>
      <h3 className="font-display font-semibold text-white text-lg leading-tight">{stage.title}</h3>
    </div>
    <p className="text-brand-textSec text-sm leading-relaxed">{stage.desc}</p>
  </div>
);

export const TimelineSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-brand-surface relative" data-testid="timeline-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>The Journey Timeline</SectionLabel>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            NINE STEPS FROM HOBBY TO BUSINESS
          </h2>
          <p className="mt-5 text-brand-textSec leading-relaxed">
            This is the plan, not a promise. Each stage will be documented as it happens — and more stages
            can be added as the project grows.
          </p>
        </Reveal>

        <div className="mt-16 relative">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-brand-cyan/40 via-white/10 to-transparent md:-translate-x-1/2" />

          <div className="space-y-8 md:space-y-14">
            {JOURNEY_STAGES.map((stage, i) => {
              const left = i % 2 === 0;
              return (
                <Reveal key={stage.n} delay={0.05}>
                  <div className="relative flex md:grid md:grid-cols-[1fr_auto_1fr] md:gap-10 items-center">
                    {/* left column (desktop) */}
                    <div className="hidden md:block">{left && <StageCard stage={stage} align="right" />}</div>

                    {/* node */}
                    <div className="absolute left-0 md:static md:justify-self-center top-1 z-10">
                      <div className="h-10 w-10 rounded-full bg-brand-elevated border border-brand-cyan/40 grid place-items-center glow-cyan">
                        <div className="h-3 w-3 rounded-full bg-brand-cyan" />
                      </div>
                    </div>

                    {/* mobile card + right column (desktop) */}
                    <div className="pl-14 md:pl-0 w-full">
                      <div className="md:hidden">
                        <StageCard stage={stage} />
                      </div>
                      <div className="hidden md:block">{!left && <StageCard stage={stage} align="left" />}</div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
